exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hpid-sign-in-page .hpid-details{margin-top:16px}.hpid-sign-in-page .hpid-details i{font-style:normal;color:#e6734b}.hpid-sign-in-page .md-button{margin:16px 0 0}.hpid-sign-in-page .cancel{color:#0096d6;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/accept/hpid-sign-in/hpid-sign-in.scss
// module id = 131
// module chunks = 0